var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-wrapper',{attrs:{"label":_vm.label,"sort":_vm.sort}},[_c('ul',{staticClass:"bg-column--tags"},_vm._l((_vm.renderList),function(value,index){return _c('li',{key:index,staticClass:"bg-column--tag"},[_vm._v(" "+_vm._s(value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }